import React, { Component } from 'react'

export default class Whatsapp extends Component {
  render() {
    return (
        <a href={`https://wa.me/`+this.props.phone} target="_blank" rel="noreferrer">
            <img src="/images/ws.png" 
            width={this.props.width} 
            height={this.props.height} 
            alt="waImage"/>
        </a>
    )
  }
}
